// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9CU-N","newExpiryDate":"styles_newExpiryDate__TQ2jQ","footer":"styles_footer__2if4d"};